import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { movies, newsList } from "@/lib/content";

export default function NewsPreview() {
  const latest = newsList.slice(0, 5);
  const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Newsroom"
        title="最新影视资讯"
        description="发行动态、幕后揭秘与剧情解析讨论，编辑部每周整理值得关注的影视消息。"
        actionLabel="进入资讯栏目"
        actionTo="/news"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/news/${article.id}`}
              className="group flex flex-col gap-2 px-4 py-4 transition-colors hover:bg-background-100 md:flex-row md:items-center md:gap-5 md:px-5"
            >
              <span className="w-fit shrink-0 rounded-md bg-secondary-100 px-2 py-1 text-[11px] text-secondary-900">
                {article.category}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-sm font-semibold leading-6 text-foreground-900 line-clamp-1 transition-colors group-hover:text-primary-700 md:text-[15px]">
                  {article.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{article.summary}</p>
              </div>
              <span className="shrink-0 font-label text-xs text-foreground-400">{article.date}</span>
              <i
                className="ri-arrow-right-s-line hidden shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-accent-500 md:block"
                aria-hidden="true"
              />
            </Link>
          ))}
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-base font-bold text-foreground-950">口碑榜</h3>
            <span className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-400">Top Rated</span>
          </div>
          <div className="mt-4 flex flex-col">
            {ranking.map((movie, index) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 border-t border-background-200 py-3 first:border-t-0 first:pt-0"
              >
                <span
                  className={`font-label text-sm font-black ${
                    index < 3 ? "text-accent-500" : "text-foreground-300"
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700 line-clamp-1">
                    {movie.title}
                  </p>
                  <p className="mt-0.5 text-[11px] text-foreground-500">
                    {movie.year} · {movie.genres.join(" / ")}
                  </p>
                </div>
                <span className="font-label text-xs font-bold text-primary-700">{movie.rating.toFixed(1)}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}